export default __webpack_public_path__ + "static/media/search3Icon.1a4d3d2d.svg";